import { timelineNodes } from '../data';

const stateStyle: Record<string, { label: string; dot: string; badge: string }> = {
  done: { label: '已入库', dot: 'bg-secondary-500', badge: 'bg-secondary-100 text-secondary-900' },
  verify: { label: '已核验', dot: 'bg-accent-500', badge: 'bg-accent-100 text-accent-900' },
  open: { label: '待补证', dot: 'bg-primary-500', badge: 'bg-primary-100 text-primary-800' },
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 md:px-6 py-10 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.8fr_1.5fr]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <div className="rounded-xl bg-primary-900 p-6 md:p-8 text-background-50">
            <span className="inline-flex items-center gap-2 font-label text-xs font-semibold tracking-[0.2em] uppercase text-accent-200">
              <i className="ri-route-line w-3.5 h-3.5 flex items-center justify-center" />
              Timeline · 事件推进
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold leading-snug">
              把「关键一夜」拆成每一步
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-100/80">
              从第一条抱怨到对质前夜，证据按发生顺序落点。看每一步对应的编号素材，随时回到原始记录核对。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="inline-flex items-center gap-1.5 rounded-md bg-secondary-600/60 px-3 py-1 text-xs">
                <span className="h-1.5 w-1.5 rounded-full bg-secondary-300" />
                已入库
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500/30 px-3 py-1 text-xs">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-300" />
                已核验
              </span>
              <span className="inline-flex items-center gap-1.5 rounded-md bg-primary-500/30 px-3 py-1 text-xs">
                <span className="h-1.5 w-1.5 rounded-full bg-primary-400" />
                待补证
              </span>
            </div>
          </div>
        </div>

        <ol className="relative ml-2 flex flex-col border-l border-background-200 md:ml-6">
          {timelineNodes.map((n, i) => {
            const st = stateStyle[n.state];
            return (
              <li key={i} className="relative pb-8 pl-6 md:pl-10 last:pb-0">
                <span
                  className={`absolute -left-[5px] top-1.5 flex h-2.5 w-2.5 items-center justify-center rounded-full ring-4 ring-background-50 ${st.dot}`}
                />
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-heading text-sm font-bold text-foreground-950">{n.date}</span>
                  <span className={`inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-medium ${st.badge}`}>
                    {st.label}
                  </span>
                  <span className="text-[11px] text-foreground-500">{n.evidence}</span>
                </div>
                <h3 className="mt-2 font-heading text-lg font-bold text-foreground-950">{n.title}</h3>
                <p className="mt-1.5 max-w-2xl text-sm leading-relaxed text-foreground-600">{n.text}</p>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}